import { z } from 'zod';

export const ROLES = ['admin', 'gestor', 'colaborador', 'visualizador'] as const;
export const roleSchema = z.enum(ROLES);
export type Role = z.infer<typeof roleSchema>;

export const ROLE_LABEL: Record<Role, string> = {
  admin: 'Admin',
  gestor: 'Gestor',
  colaborador: 'Colaborador',
  visualizador: 'Visualizador',
};

export const areaSchema = z.object({
  id: z.coerce.number(),
  codigo: z.string(),
  nome: z.string(),
  cor: z.string().nullish(),
  ordem: z.coerce.number().nullish(),
  ativo: z.boolean().default(true),
});
export type Area = z.infer<typeof areaSchema>;
export const areasListSchema = z.array(areaSchema);

export const userSchema = z.object({
  id: z.union([z.string(), z.coerce.number()]).transform(String),
  name: z.string(),
  email: z.string(),
  role: z.string(),
  cargo: z.string().nullish(),
  avatar_color: z.string().nullish(),
  active: z.boolean().default(true),
  preferences: z.record(z.unknown()).nullish(),
  // tenant_id é UUID no banco (não number). Antes era coerce.number e
  // virava NaN no parse, gerando "Resposta inválida" no edit.
  tenant_id: z.string().nullish(),
  created_at: z.string().nullish(),
  last_login: z.string().nullish(),
  // M:N com tabela area
  areas: z.array(areaSchema).default([]),
});
export type User = z.infer<typeof userSchema>;

export const usersListSchema = z.array(userSchema);

export const createUserSchema = z.object({
  name: z.string().min(2, 'Nome muito curto').max(120),
  email: z.string().email('E-mail inválido'),
  cargo: z.string().max(120).optional().or(z.literal('')),
  role: roleSchema.default('colaborador'),
});
export type CreateUserInput = z.infer<typeof createUserSchema>;

export const createUserResponseSchema = userSchema.extend({
  temp_password: z.string().optional(),
});

export const updateUserSchema = z.object({
  name: z.string().min(2).max(120).optional(),
  cargo: z.string().max(120).optional(),
  role: roleSchema.optional(),
  active: z.boolean().optional(),
  area_ids: z.array(z.number()).optional(),
});
export type UpdateUserInput = z.infer<typeof updateUserSchema>;

export const okSchema = z.object({ ok: z.boolean() });
